<template>
  <div class="mt55">
    <div
      class="w1200"
      v-show="isShow"
    >
      <div class="head clearfix">
        <HT
          text="wstage"
          style="margin-top:0px;margin-left:-35px;float:left"
        />
        <div class="fr bread clearfix">
          <div
            class="fl"
            style="margin-right:15px;color: #064186"
          >
            当前位置:
          </div>
          <div class="fl">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">
                首页
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/warehouse/wconcept' }">
                医药共享仓
              </el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/warehouse/wstage' }">
                所处阶段
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
      </div>
      <div class="content clearfix pr">
        <div class="demo-image__lazy">
          <el-image
            v-for="url in urls"
            :key="url"
            :src="url"
            lazy
          />
        </div>
        <!-- <div v-for="(item,index) in list" :key="index" class="pr">
                  <div class="title">{{ item.date }}</div>
                  <div  class="text clearfix" v-for="(itemC,index) in item.sub" :key="index">
                      <div class="fl" style="width:150px;text-indent:60px;">{{ itemC.date }}</div>
                      <div class="fl" style="margin-left:50px" v-html="itemC.text"></div>
                  </div>
              </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import HT from '@/components/h2.vue'
import { request } from '@/assets/utils/request'

export default {
    data() {
        return {
            list: [],
            isShow: true,
            urls: [
                require('../../../assets/images/wstage.jpg'),
            ]
        }
    },
    components: {
        HT
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/fzlc.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        }
    },
    mounted() {
        this.getList()
    }
}
</script>

<style scoped>
    .w1200{
        margin: 0 auto;
    }
    .bread{
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        margin-top: 50px;
    }
    .el-breadcrumb{
        line-height: 20px;
    }
    .head{
        padding-bottom: 23px;
        border-bottom: 2px solid #134b8c;
    }
    .content{
        /* padding: 1px 30px 20px 30px; */
        /* border-left: 8px solid #033f85; */
        /* margin: 35px 0 200px 30px; */
        /* 清楚图片文字选中、蓝色覆盖效果 */
        pointer-events:none;
        -webkit-user-select:none;
        -moz-user-select:none;
        -o-user-select:none;
        user-select:none;
    }
    .content .title{
        font-size: 18px;
        margin: 50px 0 30px 0;
        color: #033f85;
        position: relative;
    }
    .content .title::before{
        display: block;
        width: 32px;
        height: 32px;
        content: "";
        position: absolute;
        left: -50px;
        top: -5px;
        background: #76bd25;
        border-radius: 32px;
    }
    .content .text{
        margin-bottom: 30px;
    }
    .content .right.text{
        width: 800px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 55px;
        text-indent: 2em;
        font-size: 16px;
        line-height: 26px;
    }
</style>

<style>
    .bread .el-breadcrumb__inner.is-link{
        color: #064186;
        font-weight: 500;
    }
    .bread .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link{
        color: #5bb62d;
    }
</style>